// @ts-strict-ignore
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
  Inject,
  NgZone
} from '@angular/core';

import { LMCodeBlockComponent } from '@list/code-block/lm-code-block.component';
import { LMCompoundFieldService } from '@services/lm-compound-field.service';

@Component({
  standalone: false,
  template: `
    <div lm-code-block>
      @for (element of codeBlockFields; track element; let last = $last) {
        <div class="field"
          [ngStyle]="{'display': 'inline-flex', 'flex-wrap': 'nowrap'}"
          >
          @if (element.displayValue.length > 0) {
            {{element.displayValue}}
          } @else {
            {{element.label}}
          }
        </div>
      }
      <input type="text"/>
    </div>`,
})

// Template must contain an input elment for an editor
export class LMCodeBlockEditorComponent implements SohoDataGridCellEditor, OnInit {
  @ViewChild(LMCodeBlockComponent, { static: true }) codeblock: LMCodeBlockComponent;

  className = '.code-block';
  name = 'codeblock';

  row: number;
  cell: number;
  value: string;
  columnDef: ListGridColumn;
  dataGrid: SohoDataGridStatic;
  listGridComponent: any;
  dataView: LMListDataView;
  flatLayout: LMFormLayoutElements;
  codeBlockFields: Array<LMListCodeBlockField> = [];

  constructor(
    private lmCompoundFieldService: LMCompoundFieldService,
    private changeDetectorRef: ChangeDetectorRef,
    private ngZone: NgZone,
    @Inject('args') private args: SohoDataGridPostRenderCellArgs) {
    this.value = args.value;
    this.columnDef = args.col as ListGridColumn;
    this.row = args.row;
    this.cell = args.cell;
    this.dataGrid = args.api;
  }

  ngOnInit() {
    this.listGridComponent = this.dataGrid.settings.userObject();
    this.dataView = this.listGridComponent.dataViewSet.data[ this.row ];
    this.flatLayout = this.columnDef.flatLayout;
  }

  val(value?: any) {
    if (value) {
      this.value = value;
    } else if (value === undefined) {
      this.value = this.lmCompoundFieldService.computeCompactFieldValue(this.dataView, this.columnDef.fieldId);
    }
    return this.value;
  }

  focus() {
    const listOpenCompactFormEvent: LMListOpenCompactFormEvent = {
      fieldId: this.columnDef.fieldId,
      title: this.columnDef.displayField.label,
      layout: this.columnDef.displayField.layout,
      dataView: this.dataView,
      row: this.row,
      cell: this.cell,
      datagrid: this.dataGrid,
      columnDef: this.columnDef
    };

    this.listGridComponent.listOpenCompactForm.emit(listOpenCompactFormEvent);
  }
}
